import React, { Component } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  ButtonGroup,
  Row,
} from "react-bootstrap";
import Modal from "react-modal";
import { inject, observer } from "mobx-react";
import { BottomModal } from "../../Modal/BottomModal";
import ModalHeard from "../../Modal/ModalHeard";
import InputMask from "react-input-mask";
import { FormLabelModal } from "../../Modal/LabelModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

@inject("PlanosStores", "ComboStores")
@observer
class ModalCadCombo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      selectedOption: "mensal",
    };
  }

  componentDidMount() {
    this.props.PlanosStores.consultaPlanoNovo();
  }

  handleCloseModal = () => {
    this.setState({ isActive: false });
    this.props.ComboStores.ClearInputs();
  };
  handleOpenModal = () => {
    this.props.ComboStores.consultaPlanoNovo();
    this.setState({ isActive: true });
  };

  handleAddComboCloseModal = (evento) => {
    evento.preventDefault();
    if (this.props.ComboStores.ChecksInputs()) {
      this.props.ComboStores.addCombo();
      this.handleCloseModal();
    } else {
    }
  };

  handleOptionChange = (changeEvent, option) => {
    if (changeEvent.target.value === "") {
      this.setState({
        selectedOption: option,
      });
    } else {
      this.setState({
        selectedOption: changeEvent.target.value,
      });
    }
  };

  render() {
    return (
      <span>
        <ButtonGroup aria-label="Basic example">
          <Button size="sm" disabled variant="outline-success">
            &nbsp;+
          </Button>
          <Button
            size="sm"
            variant="success"
            onClick={() => this.handleOpenModal()}
          >
            &nbsp;Cadastrar Produto
          </Button>
        </ButtonGroup>
        <Modal
          className="Modal_Load"
          style={{
            content: {
              width: "600px",
              height: "560px",
              left: "47%",
              top: "38%",
            },
          }}
          overlayClassName="Overlay_Load"
          isOpen={this.state.isActive}
        >
          <ModalHeard
            icon={"database"}
            titulo={"CADASTRAR COMBO"}
            onClick={() => this.handleCloseModal()}
          />
          <br />
          <div>
            <Col md={12}>
              <Form>
                <Form.Group>
                  {FormLabelModal("nome combo")}
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="inputGroupPrepend">
                        <FontAwesomeIcon icon="database" />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      name={"name"}
                      type="text"
                      placeholder="Nome Combo..."
                      onChange={(e) => this.props.ComboStores.onChange(e)}
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group>
                  {FormLabelModal("descrição")}
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="inputGroupPrepend">
                        <FontAwesomeIcon icon="align-center" />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      name={"description"}
                      componentClass="textarea"
                      placeholder="Descrição..."
                      onChange={(e) => this.props.ComboStores.onChange(e)}
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group>
                  {FormLabelModal("valor total")}
                  <Row style={{ marginLeft: "0.4%" }}>
                    <div>
                      <InputGroup.Text
                        style={{ height: "41px" }}
                        id="inputGroupPrepend"
                      >
                        R$
                      </InputGroup.Text>
                    </div>
                    <div style={{ width: "91%" }}>
                      <InputMask
                        name={"value"}
                        style={{
                          marginLeft: "-0.4%",
                          width: "100%",
                          border: "1.2px",
                          borderRadius: "4px",
                          height: "41px",
                          borderColor: "#ced4da",
                          borderStyle: "solid",
                        }}
                        mask="  9999.00"
                        maskChar={null}
                        placeholder="  Valor..."
                        onChange={(e) => this.props.ComboStores.onChange(e)}
                      />
                    </div>
                  </Row>
                </Form.Group>

                <Form.Group>
                  {FormLabelModal("plano")}
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="inputGroupPrepend">
                        <FontAwesomeIcon icon="boxes" />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      name={"plano_fk"}
                      as="select"
                      multiple
                      id={"plano_fk"}
                      onChange={(e) => this.props.ComboStores.onChange(e)}
                    >
                      <option disabled={true}>Selecione um Plano Mensal</option>
                      {this.props.ComboStores.plano.map((plano, i) => {
                        return (
                          <option key={i} value={plano.id}>
                            {plano.name}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </InputGroup>
                </Form.Group>

                <div style={{ textAlign: "right" }}>
                  <Button
                    variant="outline-success"
                    size={"sm"}
                    onClick={(evento) => this.handleAddComboCloseModal(evento)}
                  >
                    Cadastrar
                  </Button>
                  <Button
                    variant="outline-danger"
                    size={"sm"}
                    onClick={() => this.handleCloseModal()}
                    style={{ marginLeft: "10px" }}
                  >
                    Fechar
                  </Button>
                </div>
              </Form>
            </Col>
          </div>
          {BottomModal}
        </Modal>
      </span>
    );
  }
}

export default ModalCadCombo;
